import React from 'react';
import { X, ArrowDown, ArrowUp, ArrowLeftRight, Receipt } from 'lucide-react';
import './TransactionDetailModal.css';

const TransactionDetailModal = ({ 
  isOpen, 
  transaction, 
  onClose 
}) => {
  if (!isOpen || !transaction) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  const getTransactionTypeIcon = (type) => {
    switch (type?.toLowerCase()) {
      case 'deposit':
      case 'add':
        return <ArrowDown size={16} />;
      case 'withdrawal':
      case 'remove':
        return <ArrowUp size={16} />;
      default:
        return <ArrowLeftRight size={16} />;
    }
  };

  const getTransactionTypeColor = (type) => {
    switch (type?.toLowerCase()) {
      case 'deposit':
      case 'add':
        return 'success';
      case 'withdrawal':
      case 'remove':
        return 'danger';
      default:
        return 'info';
    }
  };

  return (
    <div className="transaction-detail-overlay" onClick={onClose}>
      <div className="transaction-detail-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>
            <Receipt size={20} />
            Transaction Details
          </h3>
          <button className="close-btn" onClick={onClose} title="Close">
            <X size={20} />
          </button>
        </div>
        
        <div className="modal-content">
          <div className="transaction-summary">
            <div className={`transaction-type-badge ${getTransactionTypeColor(transaction.type)}`}>
              {getTransactionTypeIcon(transaction.type)}
              <span>{transaction.type?.charAt(0).toUpperCase() + transaction.type?.slice(1)}</span>
            </div>
            <div className="transaction-amount">
              {transaction.type === 'deposit' || transaction.type === 'add' ? '+' 
                : transaction.type === 'withdrawal' || transaction.type === 'remove' ? '-' : ''}
              {formatCurrency(transaction.amount)}
            </div>
          </div>

          <div className="transaction-details-grid">
            <div className="detail-row">
              <label>Transaction ID</label>
              <span className="transaction-id">{transaction.transactionId}</span>
            </div>

            <div className="detail-row">
              <label>Status</label>
              <span className={`status-badge ${transaction.status}`}>
                {transaction.status?.charAt(0).toUpperCase() + transaction.status?.slice(1)}
              </span>
            </div>

            <div className="detail-row">
              <label>Currency</label>
              <span>{transaction.currency}</span>
            </div>

            <div className="detail-row">
              <label>Balance Before</label>
              <span className="balance-before">{formatCurrency(transaction.balanceBefore)}</span>
            </div>

            <div className="detail-row">
              <label>Balance After</label>
              <span className="balance-after">{formatCurrency(transaction.balanceAfter)}</span>
            </div>

            <div className="detail-row">
              <label>Created At</label>
              <span>{formatDate(transaction.createdAt)}</span>
            </div>

            {transaction.processedAt && (
              <div className="detail-row">
                <label>Processed At</label>
                <span>{formatDate(transaction.processedAt)}</span>
              </div>
            )}

            {transaction.user && (
              <>
                <div className="detail-row">
                  <label>User ID</label>
                  <span className="user-id">{transaction.user.uid}</span>
                </div>
                <div className="detail-row">
                  <label>User Email</label>
                  <span className="user-email">{transaction.user.email}</span>
                </div>
              </>
            )}

            {transaction.description && (
              <div className="detail-row full-width">
                <label>Description</label>
                <span className="description">{transaction.description}</span>
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-close-modal" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetailModal;
